<template>
  <v-container id="reset-password-confirm-view" class="fill-height" tag="section">
    <v-row justify="center">
      <v-col cols="12" md="9" lg="6">
        <v-slide-y-transition appear>
          <v-card flat class="pa-3 pa-md-10 mx-sm-auto">
            <company-logo />
            <v-card-title class="justify-center text-h3">
              Zapomniałeś hasła?
            </v-card-title>
            <v-card-subtitle class="text-center">
              Podaj adres e-mail, a wyślemy Ci wiadomość z linkiem do resetowania hasła.
            </v-card-subtitle>
            <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
              <v-form ref="form" autocomplete="on" @submit.prevent="handleSubmit(resetPassword)">
                <v-card-text class="text-center">
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="email" rules="required|email" :debounce="200">
                      <v-text-field outlined class="" id="user-email" v-model="email" :label="$t('signin.email')"
                        autocomplete="user-email"
                        :error-messages="errors" />
                    </validation-provider>
                  </v-col>
                  <v-btn color="primary" rounded large type="submit" :disabled="invalid" :loading="loading"
                    class="mr-2">
                    {{ $t("signin.reset.password") }}
                  </v-btn>
                  <v-btn color="primary" depressed rounded large text @click="signin">
                    {{ $t("signin.button") }}
                  </v-btn>
                </v-card-text>
              </v-form>
            </validation-observer>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { resetPassword } from "@/services/auth.service"
import vue from "vue"

export default {
  name: "PasswordResetConfirm",

  data: () => ({
    loading: false,
    email: null
  }),
  beforeMount() {},
  methods: {
    signin() {
      this.$router.push({ name: "SignIn" })
    },
    resetPassword() {
      if (this.loading) {
        return
      }
      if (this.$refs.form.validate()) {
        this.loading = true
        resetPassword(this.email)
          .then(response => {
            console.log('response :>> ', response);
            this.$dialog.notify.info(response.detail, {
                timeout: 10000
              })
            this.$router.push({ name: "SignIn" })
          })
          .catch(error => {
            this.loading = false
            vue.$log.error(`Incorect login/password ${error}`, error.response?.data)
            const data = error.response?.data
            if (data == null) {
              return
            }
            if (data.email) {
              for (const message of data.email) {
                this.$dialog.notify.error(message, {
                  timeout: 10000
                })
              }
            }
          })
      }
      return false
    }
    // loginMock: function () {
    //
    //   this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
    //     this.$router.push('/')
    //   })
    // }
  }
}
</script>
